const APPLE_PAY_BUTTON_CLASS_NAME = 'bg-black text-white hover:bg-black/90 dark:bg-white dark:text-black dark:hover:bg-white/90';
const APPLE_PAY_ICON_CLASS_NAME = 'text-white dark:text-black';

export { APPLE_PAY_BUTTON_CLASS_NAME, APPLE_PAY_ICON_CLASS_NAME };
